import URI from 'urijs';

export const buildApiUri = (apiUri, ...segments) =>
  segments
    .reduce((uri, segment) => uri.segment(String(segment)), new URI(apiUri))
    .toString();

export const parseQueryParams = (queryParams) => {
  const params = Object.keys(queryParams)
    .filter((p) => queryParams[p])
    .map((p) => `${p}=${encodeURIComponent(queryParams[p])}`);
  const queryString = params.join('&');

  return queryString;
};

export const getIdFromUrl = ({ url, parseToInt = true }) => {
  const lastSlashIndex = url.lastIndexOf('/');
  const id = url.substring(lastSlashIndex + 1);
  return parseToInt ? parseInt(id) : id;
};

export const capitalizeString = (str) =>
  `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`;

export const addTrailingSlash = (value) => value?.endsWith('/') ? value : `${value}/`;
